import Vue from 'vue';
// import { validationMixin } from 'vuelidate';
import { mapGetters } from 'vuex';
import merge from 'Utils/lodash.merge';
import get from 'Utils/lodash.get';
import toasterMixin from 'Mixins/./toasterMixin';
import { getClosestElement } from 'Utils/dom';
import { scrollToElement, scrollToTop } from 'Utils/view';
import CONFIG from 'Config';
import { SERVER_GENERAL_ERROR_MESSAGE } from 'Config/constans';

// Merge strategy for validation options
// Merging rules from component and from model
Vue.config.optionMergeStrategies.validations = (toVal, fromVal) => {
  if (!toVal) return fromVal;
  if (!fromVal) return toVal;
  return function mergeValidations() {
    const toValObj = typeof toVal === 'function' ? toVal.call(this) : toVal;
    const fromValObj = typeof fromVal === 'function' ? fromVal.call(this) : fromVal;
    merge(toValObj, fromValObj);
    return toValObj;
  };
};

export default {
  mixins: [toasterMixin],
  data() {
    return {
      $_form_showServeErrorAsToaster: false,
    };
  },
  computed: {
    ...mapGetters('view', [
      'scrollOffsetTop',
    ]),
    $_form_scrollOffsetTop() {
      return this.scrollOffsetTop;
    },
  },
  watch: {
    $_form_validations: '$_form_setValidations',
    model: '$_form_setValidations',
    'model.$sendAttempts': 'scrollOnError',
    'model.$validationsRules': {
      handler() {
        if (get(this.model, '$scrollToErrorFieldOnRulesChange')) this.scrollOnError();
      },
      deep: true,
    },
  },
  beforeCreate() {
    const { $options } = this;
    if (!$options) return;
    let { validations } = $options;
    if (!validations) return;
    if (typeof validations === 'object') validations = () => validations;
    $options.computed.$_form_validations = validations;
  },
  created() {
    this.$_form_setValidations();
  },
  methods: {
    $_form_setValidations() {
      if (!this.$_form_validations || !this.model) return;
      this.model.$addValidationRules(this.$_form_validations);
    },
    // Get scroll offset to element for modal
    // Some modals has header. That modals has class .modal-full__with-header
    _getModalScrollOffset(modalElement) {
      try {
        if (!modalElement.classList.contains('modal-full__with-header')) return 0;
        const header = modalElement.querySelector('.modal-header');
        return header.getBoundingClientRect().height * -1;
      } catch (e) {
        return 0;
      }
    },
    scrollOnError() {
      this.$nextTick(() => {
        if (this.model && this.model.$scrollToErrorField && get(this, 'model.$v.$error')) {
          this.scrollToErrorFormGroup();
        }
      });
    },
    scrollToErrorFormGroup() {
      try {
        // Get form element
        const formElement = this.$_form_getFormElement();
        // Get is element in modal
        const modalElement = getClosestElement(formElement, '.v-dialog--active');
        // Get all invalid inputs
        const errorInputs = formElement.querySelectorAll('.base-form-group--error,.form-block-validation-error');
        // Get first visible invalid input
        let visibleInput = Array.from(errorInputs).find(input => input.offsetParent);
        // if form group checkbox group
        if (visibleInput.classList.contains('base-form-group--checkbox-group')) {
          // find exactly error checkbox
          visibleInput = visibleInput.querySelector('.input-checkbox--error');
        }
        // get scroll offset for modal or set default
        const scrollOffset = modalElement
          ? this._getModalScrollOffset(modalElement)
          : this.$_form_scrollOffsetTop;
        scrollToElement(visibleInput, scrollOffset, modalElement);
      } catch (ignore) {} // eslint-disable-line
    },
    $_form_getFormElement() {
      if (this.$refs.form) return this.$refs.form.$el || this.$refs.form;
      return this.$formEl || document.querySelector('[data-app]');
    },
    $_form_onSendSuccess(response) {
      if (this.model.$messageSuccess && !this.model.$skipShowMessageOnce) {
        this.$_form_toasterId = this.$_toaster_message(this.model.$messageSuccess, {
          type: Array.isArray(this.model.$messageSuccess) ? 'info' : 'success',
        });
      }
      // Scroll to top if it required
      if (this.model.$scrollTopOnSuccess) {
        // Get form element
        const formElement = this.$_form_getFormElement();
        // Get is element in modal
        const modalElement = getClosestElement(formElement, '.v-dialog--active');
        scrollToTop(200, modalElement);
      }
      return response;
    },
    $_form_onSendError(error) {
      if (this.model.$messageErrors[error.code]) {
        this.$_form_toasterId = this.$_toaster_error(error.text);
      } else if (
        !this.model.$skipShowMessageOnce
        && (error === undefined || get(error, 'response.status') >= 500)
      ) {
        this.$_form_toasterId = this.$_toaster_error(SERVER_GENERAL_ERROR_MESSAGE);
      } else if (this.$data.$_form_showServeErrorAsToaster && this.model.__error__) {
        this.$_form_toasterId = this.$_toaster_error(this.model.__error__);
      }
      throw error;
    },
    // Only check validation without sending
    $_form_validate() {
      this.$_form_hideToaster();
      try {
        // acretrader/general#3696
        this.$_form_checkHoneypot();
        this.model.$validate();
      } catch (error) {
        this.scrollOnError();
        this.$_form_onSendError(error);
      }
    },
    async $_form_send(ignoreValidation) {
      // Hide previous toaster
      this.$_form_hideToaster();
      try {
        // acretrader/general#3696
        this.$_form_checkHoneypot();
        const response = await this.model.send(ignoreValidation);
        return this.$_form_onSendSuccess(response);
      } catch (error) {
        return this.$_form_onSendError(error);
      }
    },
    $_form_hideToaster() {
      this.$_form_toasterId = this.$_toaster_hide(this.$_form_toasterId);
    },
    /**
     * Get honeypot input and check value.
     * If it not empty, than bot fill the form because this input is hidden for users
     */
    $_form_checkHoneypot() {
      const formEl = this.$_form_getFormElement();
      const honeypotInput = formEl.querySelector(`input#${CONFIG.honeypotFieldName}[name="${CONFIG.honeypotFieldName}"]`);
      if (honeypotInput && honeypotInput.value) {
        throw this.model.$messageErrors.bot_detected;
      }
    },
  },
};
